import styled from 'styled-components';

const Trigger = styled.span`
  display: inline-block;
  cursor: pointer;
  width: 100%;
`;

export default Trigger;
